<template>
<div style="padding: 10px; margin-left: 20px; margin-right: 20px">
    <v-row justify="center" wrap>
        <v-col cols="12" style="text-align: center">
            <h2 :style="{
                      color: $store.state.currentOrg.orderSecondaryColour
                        ? $store.state.currentOrg.orderSecondaryColour
                        : $store.state.currentOrg.primaryColour,
                    }">
                SELECT ADDITIONAL PRODUCTS
            </h2>
        </v-col>
        <v-col v-for="item in paginate" :key="item.id" cols="12" sm="12" md="4" lg="2">
            <v-card hover style="borderRadius: 20px; padding:0; margin:0" class='elevation-3'>
                <v-card-title>
                    <h4 class="truncate" v-if="item.stockItem">{{item.stockItem.name}}</h4>
                    <h4 class="truncate" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.name}}</h4>
                </v-card-title>
                <v-card-subtitle>
                    <span v-if="item.stockItem">{{item.stockItem.stockType.name}}</span>
                    <span v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.deviceMake.name}}</span>
                </v-card-subtitle>
                <v-card-text :key="key" style="padding-top:0; margin-top: 0;padding-bottom:0; margin-bottom: 0">
                    <v-row justify="center" style="padding-top:0; margin-top: 0;padding-bottom:0; margin-bottom: 0">
                        <v-col cols="8" style="padding-top:0; margin-top: 0;padding-bottom:0; margin-bottom: 0">
                            <span style="font-size: 12px;" v-if="item.stockItem"> {{(item.stockItem.priceExclVat)*(1+$VAT) | currency}}</span>
                            <span style="font-size: 12px;" v-else-if="item.deviceMakeModel"> {{item.deviceMakeModel.priceInclVat | currency}}</span>
                        </v-col>
                        <v-col cols="4" style="padding-top:0; margin-top: 0;padding-bottom:0; margin-bottom: 0">
                            <v-icon @click="showDetails = true;selectedProduct = item;" medium class="white--text pb-5" color="primary">info</v-icon>
                        </v-col>
                        <v-col cols="12" sm="12" md="6" style="margin: 0; text-align: center">
                            <v-btn small color="light-green" class="white--text" v-if="!item.selectedProduct" rounded @click="addToCart(item)">
                                <v-icon>add_circle_outline</v-icon> Add to Cart
                            </v-btn>
                            <v-btn small color="light-green" class="white--text" outlined v-if="item.selectedProduct" rounded @click="addToCart(item)">
                                <v-icon>check</v-icon> Added
                            </v-btn>

                            <!-- <v-icon color="light-green">add_circle_outline</v-icon> -->
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <v-row style="margin-left: 20px; margin-right: 20px">
        <v-btn rounded color="primary" @click="back()">
            <v-icon>chevron_left</v-icon> Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn rounded color="primary" @click="proceed()"> Next <v-icon>chevron_right</v-icon>
        </v-btn>
    </v-row>
    <v-form>

        <!-- <v-form v-if="this.$vuetify.breakpoint.xsOnly" >
        <v-container flat style="text-align:left " id="packageList">
            
           <v-row>
             
                <v-col  cols="6" sm="6" v-for="item in paginate" :key="item.id" >                    
                     <div class="elevation-5" style="text-align:left; padding:0px; cursor:pointer;"  hover  height="210px" name="packageCard"  :id="item.id">
                        <v-responsive v-if="item.stockItem" class="pt-4 px-2">                        
                            <v-img v-if="item.stockItem.image" :src="item.stockItem.image" height="50" aspect-ratio="1.4" contain></v-img>
                            <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>

                        </v-responsive>
                        <v-responsive v-else-if="item.deviceMakeModel" class="pt-4 px-2">                        
                            <v-img v-if="item.deviceMakeModel.image" :src="item.deviceMakeModel.image" height="50" aspect-ratio="1.4" contain></v-img>
                           <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>

                        </v-responsive>
                   <v-responsive v-else class="pt-4 px-2">                        
                            <v-img src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-card-text>                       
                               <h4 class="truncate"  v-if="item.stockItem">{{item.stockItem.name}}</h4>
                                <h4 class="truncate" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.name}}</h4>
                              
                <h5 class="truncate" :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-if="item.stockItem">{{item.stockItem.stockType.name}}</h5>
                <h5 class="truncate" :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.deviceMake.name}}</h5>

              <span style="font-size: 12px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-if="item.stockItem"> {{(item.stockItem.priceExclVat)*(1+$VAT) | currency}}</span>
              <span style="font-size: 12px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-else-if="item.deviceMakeModel"> {{item.deviceMakeModel.priceInclVat | currency}}</span>
            
                        </v-card-text>  
                         <v-toolbar 
                        :dense="true"
                        :flat="true"
                      >   
                          <v-checkbox @change="addToCart(item)" v-model="item.selectedProduct"
                             ></v-checkbox>      
                             <div class="flex-grow-1"></div>
                          <v-icon @click="showDetails = true;selectedProduct = item;" medium class="white--text pb-5" color="primary" >info</v-icon>
                      </v-toolbar>                
                            
                      </div>
                </v-col>
            </v-row>
            </v-container>
            <v-container  style="text-align:center;">
                    <v-row>
                    <v-col cols="4" sm="3">       
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                     </v-col>
                     
                    <v-col cols="4" sm="3">  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" rounded small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                      </v-col>
                    <v-col cols="4" sm="3"> 
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
           </v-col></v-row>
        </v-container>
     </v-form>

     <div v-if="this.$vuetify.breakpoint.smOnly">
        <v-container max-width="180px" class="px-2" flat style="text-align:left; px-0" id="packageList" >
           <v-row >
                <v-col cols="4" sm="4" v-for="item in paginate" :key="item.id">                    
                    <div class="elevation-5" style="text-align:left; padding:0px;cursor:pointer;"  hover height="450px" max-width="180px" name="packageCard" :id="item.id">
                          <v-responsive v-if="item.stockItem" class="pt-4 px-2">                        
                              <v-img v-if="item.stockItem.image" :src="item.stockItem.image" height="50" aspect-ratio="1.4" contain></v-img>
                            <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-responsive v-else-if="item.deviceMakeModel" class="pt-4 px-2">                        
                           <v-img v-if="item.deviceMakeModel.image" :src="item.deviceMakeModel.image" height="50" aspect-ratio="1.4" contain></v-img>
                           <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                   <v-responsive v-else class="pt-4 px-2">                        
                            <v-img src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-card-text>                       
                              <h4 class="truncateSm"  v-if="item.stockItem">{{item.stockItem.name}}</h4>
                               <h4 class="truncateSm"  v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.name}}</h4>
                               
               <h5 class="truncateSm"  :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-if="item.stockItem">{{item.stockItem.stockType.name}}</h5>
               <h5 class="truncateSm"  :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.deviceMake.name}}</h5>

              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-if="item.stockItem"> {{(item.stockItem.priceExclVat)*(1+$VAT) | currency}}</span>
              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-else-if="item.deviceMakeModel"> {{item.deviceMakeModel.priceInclVat | currency}}</span>
            
                        </v-card-text>                     
                            <v-toolbar 
                        :dense="true"
                        :flat="true"
                      >   
                          <v-checkbox @change="addToCart(item)" v-model="item.selectedProduct"
                           ></v-checkbox>      
                             <div class="flex-grow-1"></div>
                          <v-icon @click="showDetails = true;selectedProduct = item;" medium class="white--text pb-5" color="primary" >info</v-icon>
                      </v-toolbar>  
                      </div>
                </v-col>
            </v-row>
            </v-container>
            <v-container  style="text-align:center;">
                            <v-row>
                    <v-col cols="6" sm="4">   
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" rounded small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
</v-col></v-row>
        </v-container>
     </div>
      <div v-if="this.$vuetify.breakpoint.mdOnly">
        <v-container  class="px-2" flat style="text-align:left px-0" id="packageList" >
           <v-row >
                <v-col  v-for="item in paginate" :key="item.id">                    
                    <div  class="elevation-5" style="text-align:left; padding:0px;cursor:pointer;" hover height="450px" max-width="180px" name="packageCard" :id="item.id">
                         <v-responsive v-if="item.stockItem" class="pt-4 px-2">                        
                              <v-img v-if="item.stockItem.image" :src="item.stockItem.image" height="50" aspect-ratio="1.4" contain></v-img>
                            <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-responsive v-else-if="item.deviceMakeModel" class="pt-4 px-2">                        
                         <v-img v-if="item.deviceMakeModel.image" :src="item.deviceMakeModel.image" height="50" aspect-ratio="1.4" contain></v-img>
                           <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                   <v-responsive v-else class="pt-4 px-2">                        
                            <v-img src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                         <v-card-text>                       
                               <h4 class="truncateSm"  v-if="item.stockItem">{{item.stockItem.name}}</h4>
                               <h4 class="truncateSm"  v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.name}}</h4>
                              
               <h5 class="truncateSm"  :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-if="item.stockItem">{{item.stockItem.stockType.name}}</h5>
              <h5 class="truncateSm"  :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.deviceMake.name}}</h5>

              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-if="item.stockItem"> {{(item.stockItem.priceExclVat)*(1+$VAT) | currency}}</span>
              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-else-if="item.deviceMakeModel"> {{item.deviceMakeModel.priceInclVat | currency}}</span>
            
            
                        </v-card-text>                     
                            <v-toolbar 
                        :dense="true"
                        :flat="true"
                      >   
                          <v-checkbox @change="addToCart(item)" v-model="item.selectedProduct"
                            ></v-checkbox>      
                             <div class="flex-grow-1"></div>
                          <v-icon @click="showDetails = true;selectedProduct = item;" medium class="white--text pb-5" color="primary" >info</v-icon>
                      </v-toolbar> 
                      </div>
              </v-col>
            </v-row>
            </v-container>
             <v-container  style="text-align:center;">
                            <v-row>
                    <v-col cols="6" sm="4">   
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" rounded small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
</v-col></v-row>
        </v-container>
     </div>

      <div v-if="$vuetify.breakpoint.lgAndUp">
        <v-container  class="px-2" flat style="text-align:left px-0" id="packageList" >
           <v-row >
                <v-col cols="12" sm="2" v-for="item in paginate" :key="item.id">                    
                    <div  class="elevation-5" style="text-align:left; padding:0px;cursor:pointer;"  hover height="450px" max-width="180px" name="packageCard" :id="item.id">
                        <v-responsive v-if="item.stockItem" class="pt-4 px-2">                        
                              <v-img v-if="item.stockItem.image" :src="item.stockItem.image" height="50" aspect-ratio="1.4" contain></v-img>
                            <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-responsive v-else-if="item.deviceMakeModel" class="pt-4 px-2">                        
                               <v-img v-if="item.deviceMakeModel.image" :src="item.deviceMakeModel.image" height="50" aspect-ratio="1.4" contain></v-img>
                           <v-img v-else src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                   <v-responsive v-else class="pt-4 px-2">                        
                            <v-img src="../noImage.png" height="50" aspect-ratio="1.4" contain></v-img>
                        </v-responsive>
                        <v-card-text>                       
                               <h4 class="truncateSm" v-if="item.stockItem">{{item.stockItem.name}}</h4>
                              <h4 class="truncateSm" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.name}}</h4>
                              
              <h5 class="truncateSm" :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-if="item.stockItem">{{item.stockItem.stockType.name}}</h5>
              <h5 class="truncateSm" :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" v-else-if="item.deviceMakeModel">{{item.deviceMakeModel.deviceMake.name}}</h5>

              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-if="item.stockItem"> {{(item.stockItem.priceExclVat)*(1+$VAT) | currency}}</span>
              <span style="font-size: 17px;" :style="{color: $store.state.currentOrg.orderPrimaryColour?$store.state.currentOrg.orderPrimaryColour:$store.state.currentOrg.primaryColour}" v-else-if="item.deviceMakeModel"> {{item.deviceMakeModel.priceInclVat | currency}}</span>
            
                        </v-card-text>                     
                              <v-toolbar 
                        :dense="true"
                        :flat="true"
                      >   
                          <v-checkbox @change="addToCart(item)" v-model="item.selectedProduct"
                             ></v-checkbox>      
                             <div class="flex-grow-1"></div>
                          <v-icon @click="showDetails = true;selectedProduct = item;" medium class="white--text pb-5" color="primary" >info</v-icon>
                      </v-toolbar> 
                      </div>
              </v-col>
            </v-row>
            </v-container> -->
        <!-- <v-container  style="text-align:center;">
                            <v-row>
                    <v-col cols="6" sm="4">   
                        <v-btn depressed v-if="currentPage!==1&&totalPages>1" small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <v-btn depressed v-else v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage -1)">
                            <v-icon>chevron_left</v-icon>
                        </v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                                <v-btn depressed v-for="pageNumber in totalPages"  v-if="currentPage===pageNumber&&totalPages>1" rounded small color="primary" @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                            <v-btn depressed class="hidden-sm-and-down" v-else-if="totalPages>1&&(pageNumber===(currentPage+1)||pageNumber===(currentPage-1)||(currentPage===1&&pageNumber===3)||(currentPage===totalPages&&pageNumber===(totalPages-2)))" small color="grey" text @click="setPage(pageNumber)">{{pageNumber}}</v-btn>
                        </v-col>
                         <v-col cols="6" sm="4">  
                        <v-btn depressed v-if="currentPage<totalPages&totalPages>1" small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
                        <v-btn depressed v-else  v-show="totalPages>1" disabled small color="grey" text @click="setPage(currentPage +1)">
                            <v-icon >chevron_right</v-icon>
                        </v-btn>
</v-col></v-row>
        </v-container>
     </div> -->
        <v-dialog v-model="showDetails" persistent min-width="200px" max-width="800px" :fullscreen="$vuetify.breakpoint.mobile">
            <v-card>
                <v-toolbar color="white">
                    <v-toolbar-title>
                        <span :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" class="mr-4 font-weight-bold" v-if="selectedProduct.stockItem">{{selectedProduct.stockItem.name}}</span>
                        <span :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" class="mr-4 font-weight-bold" v-else-if="selectedProduct.deviceMakeModel">{{selectedProduct.deviceMakeModel.name}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showDetails=false">X</v-btn>
                </v-toolbar>
                <!-- <v-card-title class="headline"  primary-title>
                      <v-responsive v-if="selectedProduct.stockItem" class="pt-4 px-2">
                     <v-img :src="selectedProduct.stockItem.image" px-5 max-height="55" aspect-ratio="1.4" contain style="text-align: left;"></v-img> 
                      </v-responsive>
                      <v-responsive v-else-if="selectedProduct.deviceMakeModel" class="pt-4 px-2">
                     <v-img :src="selectedProduct.deviceMakeModel.image" px-5 max-height="55" aspect-ratio="1.4" contain style="text-align: left;"></v-img> 
                      </v-responsive>
                    <v-spacer></v-spacer>
                   
                </v-card-title> -->
                <v-divider></v-divider>
                <br>
                <v-card-text>
                    <v-row row wrap>
                        <v-col>
                            <v-form style="text-align: left; padding: 15px">
                                <h2 :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}" class="text-xs-center">Product details</h2>
                                <v-container grid-list-xs>
                                    <v-row wrap>
                                        <v-col class=" text-xs-left px-0">
                                            <h4>Product Name: </h4>
                                            <h4>Type: </h4>
                                            <h4>Price (VAT Incl.): </h4>
                                        </v-col>
                                        <v-col class="text-xs-left px-0">
                                            <h4><b v-if="selectedProduct.stockItem">{{selectedProduct.stockItem.name}}</b><b v-else>{{selectedProduct.deviceMakeModel.name}}</b></h4>
                                            <h4><b v-if="selectedProduct.stockItem">{{selectedProduct.stockItem.stockType.name}}</b><b v-else>{{selectedProduct.deviceMakeModel.deviceMake.name}}</b></h4>
                                            <h4><b v-if="selectedProduct.stockItem">{{(selectedProduct.stockItem.priceExclVat)*(1+$VAT)|currency}}</b><b v-else>{{selectedProduct.deviceMakeModel.priceInclVat|currency}}</b></h4>
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap v-if="selectedProduct.stockItem">
                                        <v-col v-if="selectedProduct.stockItem.description!==null&&selectedProduct.stockItem.description!==''" style="text-align: left; padding: 15px">
                                            <v-form :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}">
                                                {{selectedProduct.stockItem.description}}
                                            </v-form>
                                        </v-col>
                                    </v-row>
                                    <v-row row wrap v-else>
                                        <v-col v-if="selectedProduct.deviceMakeModel.description!==null&&selectedProduct.deviceMakeModel.description!==''" style="text-align: left; padding: 15px">
                                            <v-form :style="{color: $store.state.currentOrg.orderSecondaryColour?$store.state.currentOrg.orderSecondaryColour:$store.state.currentOrg.secondaryColour}">
                                                {{selectedProduct.deviceMakeModel.description}}
                                            </v-form>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-col>
                    </v-row>

                </v-card-text>
               
            </v-card>
        </v-dialog>

    </v-form>
</div>
</template>

<script>
export default {
    props: ["productCards", "cardsPerPage", "sizeScreen", "keepColor"],
    data() {
        return {
            selectedArray: [],
            contentProps: {
                wrap: false,
                row: false
            },
            key: 0,
            pageNumber: 0,
            currentPage: 1,
            itemsPerPage: this.cardsPerPage,
            resultCount: 0,
            show: false,
            showDetails: false,
            moreInfoClicked: false,
            selectedId: null,
            selectedProduct: {
                organisation: {},
                stockItem: {
                    stockType: {}
                }
            },
            packageObj: {},
            styleTrue: true,
        };
    },
    computed: {
        totalPages: function () {
            return Math.ceil(this.resultCount / this.cardsPerPage)
        },
        paginate: function () {
            if (!this.productCards || this.productCards.length != this.productCards.length) {
                return
            }

            this.resultCount = this.productCards.length
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
            }
            var index = this.currentPage * this.cardsPerPage - this.cardsPerPage
            return this.productCards
        }
    },
    methods: {
        addToCart(item) {
            item.selectedProduct = !item.selectedProduct
            this.key++
            if (item.selectedProduct == true) {
                this.selectedArray.push(item)
                this.$emit('selectProduct', this.selectedArray)
            } else {
                let index = this.selectedArray.indexOf(item)
                this.selectedArray.splice(index, 1)
                this.$emit('selectProduct', this.selectedArray)
            }
        },
        back(){
            this.$emit('back')
        },
        setPage: function (pageNumber) {
            this.currentPage = pageNumber
        },
        clearPackageSelection() {
            let elements = document.getElementsByName("packageCard")
            for (let i = 0; i < elements.length; i++) {
                elements[i].style.border = "none";
                elements[i].style.backgroundColor = "white";
            }
        },
        proceed() {
            this.$emit('proceed')
        },
        selectProduct(id, obj) {
            this.clearPackageSelection();
            if (id != this.selectedId) {
                this.selectedId = id
                document.getElementById(id).style.backgroundColor = "#e6e6e6";
                document.getElementById(id).style.border = "1px solid #99cc33";

                this.$emit('selectProduct', obj)
            } else if (id == this.selectedId) {
                this.selectedId = null;
                this.$emit('selectProduct', null)
            }
        }

    }
};
</script>

<style>
    /* @media only screen and (min-width: 1904px) {
        .container {
            max-width: none !important
        }
    } */

    .mobileStep {
        font-size: 10px;
    }

    .largeStep {
        text-align: center;
        min-height: 470px;
        max-width: 160px
    }

    /* .compact-form {
        transform: scale(0.8);
        transform-origin: top;
    } */

    .compact-formInfo {
        transform-origin: top;
    }

    .greenBorder {
        background-color: #e6e6e6;
        border: 1px solid var(--primary);
        text-align: center;
    }

    .blueBorder {
        background-color: #e6e6e6;
        border: 1px solid #34c3eb;
        text-align: center;
    }

    .redBorder {
        background-color: #e6e6e6;
        border: 1px solid red;
        text-align: center;
    }

    .truncate {
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .truncateSm {
        font-size: 17px;
        max-width: 170px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
